"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoLeadership = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Size_1 = require("../../render/Size");
const SelectCard_1 = require("../../../inputs/SelectCard");
class CoLeadership extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.CO_LEADERSHIP,
            metadata: {
                cardNumber: 'Y36',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.text('Draw 3 CEO cards, and play one of them.', Size_1.Size.SMALL, true);
                }),
            },
        });
    }
    play(player) {
        const cardsDrawn = [
            player.game.dealer.dealLeaderCard(),
            player.game.dealer.dealLeaderCard(),
            player.game.dealer.dealLeaderCard(),
        ];
        return new SelectCard_1.SelectCard('Choose CEO card to play', 'Play', cardsDrawn, (foundCards) => {
            return player.playCard(foundCards[0]);
        });
    }
    ;
}
exports.CoLeadership = CoLeadership;
//# sourceMappingURL=CoLeadership.js.map